export const requestFullscreen = (() => {
	return [
		'requestFullscreen',
		'mozRequestFullScreen',
		'msRequestFullscreen',
		'webkitRequestFullscreen',
	].reduce((prev, curr) => (document.documentElement[curr] ? curr : prev));
})();

export const exitFullscreen = (() => {
	return [
		'exitFullscreen',
		'mozCancelFullScreen',
		'msExitFullscreen',
		'webkitExitFullscreen',
	].reduce((prev, curr) => (document[curr] ? curr : prev));
})();

export function fullscreenChange(type, callback) {
	[
		'fullscreenchange',
		'mozfullscreenchange',
		'MSFullscreenChange',
		'webkitfullscreenchange',
	].forEach(vendor => document[`${type}EventListener`](vendor, callback));
}

export const isFullscreenSupported = Boolean(
	document.documentElement[requestFullscreen]
);
